export default {
  locale: 'zh-CN',
  filter: {
    all: '全部',
    filter: '筛选',
    reset: '重置',
    placeholder: '请输入关键字'
  },
  editableTable: {
    options: '操作',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    input: '请输入',
    addText: '新增内容',
    deleteConfirm: '是否删除当前行?'
  },
  table: {
    // tslint:disable-next-line: no-invalid-template-strings
    total: '共 ${count} 条数据'
  },
  icon: {
    robot: '自动化',
    ai: '人工智能',
    data: '大数据图标',
    file: '文档处理类图标',
    direction: '方向性图标',
    suggest: '提示建议性图标',
    edit: '编辑类图标',
    chart: '数据类图标',
    logo: '品牌标识',
    common: '网站通用图标'
  },
  tagSelect: {
    cancel: '取消',
    confirm: '确认',
    createNewTag: '创建新标签'
  }
};
